export default "__VITE_ASSET__h7BtS4h___"